import { useMemo } from 'react'

import { IApiDataType } from '../types'
import useLegalEntityFilter from './useLegalEntityFilter'

const useLegalEntityWithoutLocationsFilter = () => {
  const { data, loading } = useLegalEntityFilter()

  return {
    data: useMemo((): IApiDataType => {
      if (!data) return null

      const { values, defaultValue } = data

      return {
        values: values.filter((v) => 'list' in v || v.id === 'legal-entity'),
        defaultValue,
      }
    }, [data]),
    loading,
  }
}

export default useLegalEntityWithoutLocationsFilter
